import { useSelector } from 'react-redux';

import { RootState } from '../store';
import { ItemTaskType, ItemType, MappingItemIdIndexType } from '../types';

const useTaskPrepareForDate = () => {
    const filteredTasks = useSelector<RootState, ItemTaskType[]>((state) => state.calendar.filteredTasks);
    const items = useSelector<RootState, ItemType[]>((state) => state.calendar.items);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>(
        (state) => state.calendar.mappingItemIdIndex,
    );

    const dataDayList: {
        [keyDate: string]: { itemList: ItemType[]; taskList: ItemTaskType[] };
    } = {};
    const bufferPushedItemToList: { [key: string]: boolean } = {};

    for (const task of filteredTasks) {
        if (!dataDayList[task.datetime]) {
            dataDayList[task.datetime] = {
                itemList: [],
                taskList: [],
            };
        }

        if (task.schedule_item_id) {
            const item = items[mappingItemIdIndex[task.schedule_item_id]];
            if (item && !bufferPushedItemToList[item.id]) {
                bufferPushedItemToList[item.id] = true;
                dataDayList[task.datetime].itemList.push(items[mappingItemIdIndex[task.schedule_item_id]]);
            }
        }

        dataDayList[task.datetime].taskList.push(task);
    }

    return dataDayList;
};

export default useTaskPrepareForDate;
